import { AccountStatus, CustomerAccount } from './types'

export const isAccountActive = (customerAccount: CustomerAccount): boolean =>
  customerAccount.accountStatus === AccountStatus.ACTIVE
